import { useState } from 'react';
import { Smartphone, Wifi, WifiOff, RotateCcw } from 'lucide-react';

export const MobileFlutterPage = () => {
  const [isOnline, setIsOnline] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const handleReload = () => {
    setIsLoading(true);
    const iframe = document.getElementById('flutter-iframe') as HTMLIFrameElement;
    if (iframe) {
      iframe.src = iframe.src;
    }
  };

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="bg-white rounded-t-3xl border-2 border-gray-300 p-4 flex items-center justify-between shadow-lg">
          <div className="flex items-center gap-3">
            <Smartphone className="w-6 h-6 text-blue-700" />
            <h1 className="text-lg font-bold text-gray-800">
              Mobile Flutter
            </h1>
          </div>

          <div className="flex items-center gap-3">
            {/* Status Conexão */}
            <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${
              isOnline ? 'bg-green-100' : 'bg-red-100'
            }`}>
              {isOnline ? (
                <Wifi className="w-4 h-4 text-green-600" />
              ) : (
                <WifiOff className="w-4 h-4 text-red-600" />
              )}
              <span className={`text-xs font-semibold ${
                isOnline ? 'text-green-700' : 'text-red-700'
              }`}>
                {isOnline ? 'Online' : 'Offline'}
              </span>
            </div>

            {/* Botão Reload */}
            <button
              onClick={handleReload}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              title="Recarregar Flutter"
            >
              <RotateCcw className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        </div>

        {/* Frame do Celular */}
        <div className="relative bg-white border-x-2 border-gray-300 shadow-2xl" style={{ height: '600px' }}>
          {/* Loading Overlay */}
          {isLoading && (
            <div className="absolute inset-0 bg-white z-10 flex items-center justify-center">
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-700 mx-auto mb-4"></div>
                <p className="text-gray-600 font-medium">Carregando Flutter...</p>
              </div>
            </div>
          )}

          {/* Flutter Web iframe */}
          <iframe
            id="flutter-iframe"
            src="/flutter-app/index.html"
            className="w-full h-full border-0"
            onLoad={handleIframeLoad}
            title="Flutter App"
          />
        </div>

        {/* Footer */}
        <div className="bg-white rounded-b-3xl border-2 border-t-0 border-gray-300 p-4 shadow-lg">
          <div className="flex items-center justify-center gap-2 text-xs text-gray-500">
            <Smartphone className="w-4 h-4" />
            <span>Flutter Web - Renderização Nativa</span>
          </div>
        </div>

        {/* Info Card */}
        <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h3 className="text-sm font-semibold text-blue-900 mb-2">
            ℹ️ Sobre Flutter Web
          </h3>
          <p className="text-xs text-blue-800">
            Este é o aplicativo mobile compilado em Flutter e renderizado diretamente no navegador.
            O mesmo código será usado para gerar o APK Android.
          </p>
        </div>
      </div>
    </div>
  );
};
